
import AZStore from '../components/AZStore/AZStore'
import AZStoreList from '../components/AZStoreList/AZStoreList'
import BackToStore from '../components/BackToStore/BackToStore'
import ClickAndCollect from '../components/ClickAndCollect/ClickAndCollect'
import CollectionPoint from '../components/CollectionPoint/CollectionPoint'
import DidYouMean from '../components/DidYouMean/DidYouMean'
import ErrorBoundary from '../components/ErrorBoundary/ErrorBoundary'
import FAQs from '../components/FAQs/FAQs'
import FilterButton from '../components/Results/FilterButton/FilterButton'
import OpeningHours from '../components/OpeningHours/OpeningHours'
import Pagination from '../components/Pagination/Pagination'
import RecentLocations from '../components/RecentLocations/RecentLocations'
import Map from '../components/Map/Map'
import Search from '../components/Search/Search'
import SearchWithParam from '../components/SearchWithParam/SearchWithParam'
import SEOText from '../components/SEOText/SEOText'
import StoreFacility from '../components/StoreFacility/StoreFacility'
import StoreHeadline from '../components/Details/StoreHeadline/StoreHeadline'
import StoreInfo from '../components/Details/StoreInfo/StoreInfo'
import StoreResult from '../components/Results/StoreResult/StoreResult'
import UseLocation from '../components/UseLocation/UseLocation'
import ViewToggle from '../components/Results/ViewToggle/ViewToggle'

export {
  AZStore,
  AZStoreList,
  BackToStore,
  ClickAndCollect,
  CollectionPoint,
  DidYouMean,
  ErrorBoundary,
  FAQs,
  FilterButton,
  OpeningHours,
  Pagination,
  RecentLocations,
  Map,
  Search,
  SearchWithParam,
  SEOText,
  StoreFacility,
  StoreHeadline,
  StoreInfo,
  StoreResult,
  UseLocation,
  ViewToggle
}



// WEBPACK FOOTER //
// ./src/components/index.js